// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3l1Sh","legacyBtn":"MutateMid_legacyBtn__vyzw6"};